export var CLASS_NAME_PREFIX = 'react-select';
export var classes = {
  // Need to be same as react-select's rendered class names
  badge: ".".concat(CLASS_NAME_PREFIX, "__multi-value"),
  badgeText: ".".concat(CLASS_NAME_PREFIX, "__multi-value__label"),
  control: ".".concat(CLASS_NAME_PREFIX, "__control"),
  controlDisabled: ".".concat(CLASS_NAME_PREFIX, "__control--is-disabled"),
  controlFocused: ".".concat(CLASS_NAME_PREFIX, "__control--is-focused:not(.").concat(CLASS_NAME_PREFIX, "__control--is-disabled)"),
  controlOpen: ".".concat(CLASS_NAME_PREFIX, "__control--menu-is-open:not(.").concat(CLASS_NAME_PREFIX, "__control--is-disabled)"),
  indicators: ".".concat(CLASS_NAME_PREFIX, "__indicators"),
  input: ".".concat(CLASS_NAME_PREFIX, "__input"),
  inputContainer: ".".concat(CLASS_NAME_PREFIX, "__input-container"),
  multiValueContainer: ".".concat(CLASS_NAME_PREFIX, "__value-container--is-multi"),
  multiValueContainerWithValue: ".".concat(CLASS_NAME_PREFIX, "__value-container--is-multi.").concat(CLASS_NAME_PREFIX, "__value-container--has-value"),
  multiValueContainerWithoutValue: ".".concat(CLASS_NAME_PREFIX, "__value-container--is-multi:not(.").concat(CLASS_NAME_PREFIX, "__value-container--has-value)"),
  placeholder: ".".concat(CLASS_NAME_PREFIX, "__placeholder"),
  selectMenu: ".".concat(CLASS_NAME_PREFIX, "__menu"),
  selectMenuList: ".".concat(CLASS_NAME_PREFIX, "__menu-list"),
  selectMenuNotice: ".".concat(CLASS_NAME_PREFIX, "__menu-notice"),
  selectMenuOption: ".".concat(CLASS_NAME_PREFIX, "__option"),
  selectMenuOptionFocused: ".".concat(CLASS_NAME_PREFIX, "__option--is-focused"),
  selectMenuOptionSelected: ".".concat(CLASS_NAME_PREFIX, "__option--is-selected"),
  singleValue: ".".concat(CLASS_NAME_PREFIX, "__single-value"),
  valueContainer: ".".concat(CLASS_NAME_PREFIX, "__value-container")
};
export var CREATABLE_OPTION_KEY = '__isNew__';
export var FieldSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export var fieldSizeStyles = {
  [FieldSizes.SMALL]: {
    badgeMargin: '1px 6px 1px 0',
    font: 'body-text-x-small',
    height: 'var(--spacing-4)',
    indicatorPadding: '0 6px 0 0',
    padding: "3px 0 3px 9px",
    verticalPaddingWithBorder: '1px' /* + space between badges */
  },

  [FieldSizes.MEDIUM]: {
    badgeMargin: '3px 6px 3px 0',
    font: 'body-text-small',
    height: 'var(--spacing-6)',
    indicatorPadding: '0 9px 0 0',
    padding: "6px 0 6px 15px",
    verticalPaddingWithBorder: '5px'
  },
  [FieldSizes.LARGE]: {
    badgeMargin: '1px 6px 1px 0',
    font: 'body-text-medium',
    height: 'var(--spacing-8)',
    indicatorPadding: '0 12px 0 0',
    padding: "12px 0 12px 18px",
    verticalPaddingWithBorder: '11px'
  }
};
export var FieldWidths = {
  FULL: 'full'
};
export var Indicators = {
  CLEAR: 'clear',
  DROPDOWN: 'dropdown',
  MULTI_VALUE_REMOVE: 'multiValueRemove'
};
export var IS_CREATABLE = true;
export var MENU_POSITION = 'absolute';
export var resultsMenuSizeStyles = {
  [FieldSizes.SMALL]: {
    height: 'var(--spacing-5)',
    menuPadding: 'var(--spacing-1)',
    optionFont: 'body-text-x-small',
    optionPadding: 'var(--spacing-1) 9px'
  },
  [FieldSizes.MEDIUM]: {
    height: 'var(--spacing-6)',
    menuPadding: 'var(--spacing-2) var(--spacing-1)',
    optionFont: 'body-text-small',
    optionPadding: 'var(--spacing-1) var(--spacing-2)'
  },
  [FieldSizes.LARGE]: {
    height: 'var(--spacing-8)',
    menuPadding: 'var(--spacing-2) var(--spacing-1)',
    optionFont: 'body-text-medium',
    optionPadding: 'var(--spacing-2) var(--spacing-3)'
  }
};
export var selectMenuSharedDefaults = {
  closeMenuOnSelect: true,
  disabled: false,
  error: false,
  errorMessage: "There's an error with this field",
  fieldSize: FieldSizes.MEDIUM,
  fieldWidth: FieldWidths.FULL,
  menuPlacement: 'bottom',
  id: '',
  isClearable: true,
  isMulti: false,
  menuMaxVisible: 7,
  menuWidth: FieldWidths.FULL,
  name: '',
  placeholder: '',
  tabIndex: 0
};
export var storyOptions = [{
  label: 'Pogs',
  value: 'option1'
}, {
  label: 'Tamagotchi',
  value: 'option2'
}, {
  label: 'Slap Bracelets',
  value: 'option3'
}, {
  label: 'Etcha-a-Sketch',
  value: 'option4'
}, {
  label: 'Lite Brite',
  value: 'option5'
}, {
  label: 'Mouse Trap',
  value: 'option6'
}, {
  label: 'Marble Run',
  value: 'option7'
}];
export var defaultStoryArgTypes = {
  error: {
    defaultValue: false,
    description: 'Flag true to display the provided error message.'
  },
  errorMessage: {
    description: 'Optional error message to display if there is a true error attribute present.'
  },
  fieldSize: {
    defaultValue: 'medium'
  },
  fieldWidth: {
    control: {
      options: {
        full: 'full',
        '240 (choose your own number IRL)': 240
      },
      type: 'select'
    },
    defaultValue: 'full',
    description: 'Determines how the field is sized horizontally. Field is full-width (100%) by default, but can also be set to a numerical pixel value.'
  },
  id: {
    description: "Controls the `for` attribute and corresponds to the Field ID. Note: the ID will be applied to React-Select's child input, while '[id]-wrapper' will be applied to the main container element.",
    type: {
      summary: 'string'
    }
  },
  isClearable: {
    control: {
      type: 'boolean'
    },
    defaultValue: true,
    description: 'Allows for clearing of selection(s).',
    table: {
      defaultValue: {
        summary: 'true'
      },
      type: {
        summary: 'boolean'
      }
    }
  },
  isMulti: {
    control: {
      type: 'boolean'
    },
    defaultValue: false,
    description: 'Allows for multiple value selection.',
    table: {
      defaultValue: {
        summary: 'false'
      },
      type: {
        summary: 'boolean'
      }
    }
  },
  label: {
    description: 'The text of the Field label. If not including an explicit label, be sure to use the labelledBy property to specify an aria-labelledby attribute.',
    table: {
      type: {
        summary: 'React.ReactNode'
      }
    }
  },
  labelledBy: {
    description: 'If no label is used, specify the id of the element that describes this field.'
  },
  menuMaxVisible: {
    defaultValue: 7,
    description: "Max number of visible menu items before menu overflows and scrolls. If menu options wrap, this calculation will be less precise. If there are fewer options than the max, the menu only renders as tall as needed."
  },
  menuPlacement: {
    defaultValue: 'bottom',
    description: 'Determines where the menu appears.'
  },
  menuPosition: {
    defaultValue: 'absolute',
    table: {
      defaultValue: {
        summary: 'absolute'
      }
    }
  },
  menuWidth: {
    control: {
      type: 'select',
      options: ['full', 240]
    },
    defaultValue: 'full',
    description: 'Determines how the results menu is sized horizontally. Menu is full-width (100%) by default, but can also be set to a numerical pixel value.',
    table: {
      type: {
        summary: '"full" | number'
      }
    }
  },
  message: {
    description: 'Optional guidance message to display for the field. This will not display if an error message is present.'
  },
  name: {
    control: {
      type: 'text'
    },
    description: 'Input field name.',
    table: {
      type: {
        summary: 'string'
      }
    }
  },
  options: {
    description: 'Options in menu.',
    table: {
      type: {
        summary: 'Option<T>[]'
      }
    }
  },
  placeholder: {
    control: {
      type: 'text'
    },
    description: 'Placeholder text. Do not rely on placeholders as labels: use only as a guide.',
    table: {
      type: {
        summary: 'string'
      }
    }
  },
  required: {
    defaultValue: false,
    description: 'Displays a required indicator.'
  },
  value: {
    description: 'Array of object(s)',
    table: {
      type: {
        summary: 'Option<T>[] | [] | null | undefined'
      }
    }
  }
};